// src/components/calendar/edit/Overtime.js
import axiosInstance from "../../../config/axiosInstance";
import { logApiError } from "../../../config/apiErrorHandling";

export const OVERTIME_TYPE_LABELS = {
  extra: "Hora extra",
  recuperacion: "Hora de recuperación",
};

export const useHandleAddOvertime = () => {
  const handleAddOvertime = async ({ ci, day, station_id, hour_from, hour_to, type, reason }) => {
    try {
      const { data } = await axiosInstance.post(
        "/calendar/add_overtime",
        {},
        {
          params: {
            ci: String(ci),
            day: String(day),
            station_id: String(station_id),
            hour_from,
            hour_to,
            type,
            ...(reason ? { reason } : {}),
          },
        }
      );
      return { ok: true, data };
    } catch (error) {
      const info = logApiError(
        "calendar.overtime.add",
        error,
        "No se pudo registrar la hora extra. Intenta nuevamente."
      );
      return { ok: false, error, info };
    }
  };

  return handleAddOvertime;
};

export const useHandleUpdateOvertime = () => {
  const handleUpdateOvertime = async ({ id, station_id, hour_from, hour_to, type, reason }) => {
    try {
      const { data } = await axiosInstance.post(
        "/calendar/update_overtime",
        {},
        {
          params: {
            id: String(id),
            station_id: String(station_id),
            hour_from,
            hour_to,
            type,
            ...(reason ? { reason } : {}),
          },
        }
      );
      return { ok: true, data };
    } catch (error) {
      const info = logApiError(
        "calendar.overtime.update",
        error,
        "No se pudo actualizar la hora extra. Intenta nuevamente."
      );
      return { ok: false, error, info };
    }
  };

  return handleUpdateOvertime;
};

export const useHandleRemoveOvertime = () => {
  const handleRemoveOvertime = async ({ id, station_id }) => {
    try {
      const { data } = await axiosInstance.post(
        "/calendar/remove_overtime",
        {},
        { params: { id: String(id), station_id: String(station_id) } }
      );
      return { ok: true, data };
    } catch (error) {
      const info = logApiError(
        "calendar.overtime.remove",
        error,
        "No se pudo eliminar la hora extra. Intenta nuevamente."
      );
      return { ok: false, error, info };
    }
  };

  return handleRemoveOvertime;
};

export const fetchOvertimeForDay = async ({ ci, day }) => {
  try {
    const { data } = await axiosInstance.get("/calendar/overtime_hours", {
      params: { ci: String(ci), day: String(day) },
    });
    return Array.isArray(data?.items) ? data.items : [];
  } catch {
    return [];
  }
};
